import { Button, Group, Modal, Select, Stack, Textarea } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { changeAmlRisk } from "../../../../services/flag";
import { useCheckPermission } from "../../../../hooks/useCheckPermission";

function AmlButton() {
  const { id } = useParams();
  const amlRiskPermission = useCheckPermission("AML_INCREASE_RISK");
  const [popupOpen, setPopupOpen] = useState(false);
  const [amlSelectValue, setAmlSelectValue] = useState(null);
  const [description, setDescription] = useState("");

  const { mutate: changeRisk, isPending } = useMutation({
    mutationFn: () =>
      changeAmlRisk({
        id,
        increase: amlSelectValue === "Increase",
        description,
      }),
    onSuccess: handleClose,
    onError: (err) => {
      toast.error(err.response?.data.message);
    },
  });

  function handleClose() {
    setPopupOpen(false);
    setAmlSelectValue(null);
    setDescription("");
  }

  const isConfirmDisabled = !amlSelectValue || description.trim() === "";

  if (!amlRiskPermission) {
    return null;
  }

  return (
    <>
      <Button variant="outline" onClick={() => setPopupOpen(true)}>
        Change risk in AML
      </Button>

      <Modal
        centered
        opened={popupOpen}
        onClose={handleClose}
        withCloseButton={false}
        title="Change AML Risk"
      >
        <Stack gap="sm">
          <Select
            data={["Increase", "Decrease"]}
            placeholder="Select action"
            value={amlSelectValue}
            onChange={setAmlSelectValue}
          />
          <Textarea
            label="Description*"
            value={description}
            onChange={(e) => setDescription(e.currentTarget.value)}
          />
          <Group justify="space-around">
            <Button variant="outline" color="red" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="outline"
              color="green"
              disabled={isConfirmDisabled}
              loading={isPending}
              onClick={() => changeRisk()}
            >
              Confirm
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
}

export default AmlButton;
